__turbopack_context__.v({
  "enter": "SampleListCarousel-module-scss-module__fNX5zW__enter",
  "exit": "SampleListCarousel-module-scss-module__fNX5zW__exit",
  "fade-in": "SampleListCarousel-module-scss-module__fNX5zW__fade-in",
  "fade-out": "SampleListCarousel-module-scss-module__fNX5zW__fade-out",
  "fade-out-80": "SampleListCarousel-module-scss-module__fNX5zW__fade-out-80",
  "root": "SampleListCarousel-module-scss-module__fNX5zW__root",
  "rootPaused": "SampleListCarousel-module-scss-module__fNX5zW__rootPaused",
  "slide-in-from-bottom": "SampleListCarousel-module-scss-module__fNX5zW__slide-in-from-bottom",
  "slide-in-from-left": "SampleListCarousel-module-scss-module__fNX5zW__slide-in-from-left",
  "slide-in-from-right": "SampleListCarousel-module-scss-module__fNX5zW__slide-in-from-right",
  "slide-in-from-top": "SampleListCarousel-module-scss-module__fNX5zW__slide-in-from-top",
  "slide-out-to-bottom": "SampleListCarousel-module-scss-module__fNX5zW__slide-out-to-bottom",
  "slide-out-to-left": "SampleListCarousel-module-scss-module__fNX5zW__slide-out-to-left",
  "slide-out-to-right": "SampleListCarousel-module-scss-module__fNX5zW__slide-out-to-right",
  "slide-out-to-top": "SampleListCarousel-module-scss-module__fNX5zW__slide-out-to-top",
  "stage": "SampleListCarousel-module-scss-module__fNX5zW__stage",
  "thumb": "SampleListCarousel-module-scss-module__fNX5zW__thumb",
  "thumbCentered": "SampleListCarousel-module-scss-module__fNX5zW__thumbCentered",
  "thumbGlow": "SampleListCarousel-module-scss-module__fNX5zW__thumbGlow",
  "thumbHighlighted": "SampleListCarousel-module-scss-module__fNX5zW__thumbHighlighted",
  "thumbHovered": "SampleListCarousel-module-scss-module__fNX5zW__thumbHovered",
  "thumbImage": "SampleListCarousel-module-scss-module__fNX5zW__thumbImage",
  "thumbInner": "SampleListCarousel-module-scss-module__fNX5zW__thumbInner",
  "track": "SampleListCarousel-module-scss-module__fNX5zW__track",
  "zoom-in": "SampleListCarousel-module-scss-module__fNX5zW__zoom-in",
  "zoom-out": "SampleListCarousel-module-scss-module__fNX5zW__zoom-out",
});
